import {
    deepClone,
    headers,
    operator,
    setOtherFilters,
    unmountSelectFieldsV2,
    getOperator, 
    globalConfig,
    mountSelectFields,
} from "@/utils";
import {
    Picklist,
    QcHeader
  } from "@/types";
import { settings } from "@/settings";
import { api, apiAnonymousToken } from "@/auth/api";
import store from "@/store";

import {} from "@/utils";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import moment from "moment";
import { getInOperator } from "../picklist";
import i18n from "@/i18n";

const odm_user = `odm-user`
const baseUrl = `${settings.api_url}/${odm_user}/api/1/${odm_user}`


/**
 * Team and user lookup service for assignment and manager workflows.
 */
  /**
   * Fetches users eligible for manager assignment selectors.
   *
   * @param filter - Search filter containing role and network constraints
   * @param offset - Pagination offset
   * @param limit - Maximum number of rows to load
   * @returns API response mapped to picklist-like items
   */
  export const getUsersListToCreateManager = async (filter: any, offset? : any , limit?: any) => {
    const operators = [];
    const operatorsRoleVendor: any= [];

  
    const qc_header: QcHeader = {
      qc: {
        queryId: "user-lease-forge-user-with-usergroup",
        offset: offset || 0,
        limit: limit || 400,
        parameters: {
          ...filter,
        },
      },
    };
     
    
  
  
    if (filter && filter.networkNode) {
     
      operators.push(
        getOperator(
          "cast(userRoles",
          "network_node_id  AS text)",
          "LIKE",
          globalConfig.formatters.getLikeValue(filter.networkNode),
          "network_node_id"
          )
        );
    }
    if (filter && filter.roleCode) {
        if (filter.roleCode === "SELLER") {
          operatorsRoleVendor.push(
            getOperator(
              "cast(userRoles",
              "role_code  AS text)",
              "LIKE",
              globalConfig.formatters.getLikeValue("VENDOR"),
              "role_code"
            )
          );
          operatorsRoleVendor.push(
            getOperator(
              "cast(userRoles",
              "role_code  AS text)",
              "LIKE",
              globalConfig.formatters.getLikeValue(filter.roleCode),
              "role_code"
            )
          );
       }
       else {
          operators.push(
            getOperator(
              "cast(userGroups",
              "group_code  AS text)",
              "LIKE",
              globalConfig.formatters.getLikeValue(filter.roleCode),
              "group_code"
            )
            );
       }
    }
    if (filter && filter.id) {
      operators.push(
        operator({
          val: filter.id,
          table: "user_lease_forge_user",
          dbField: "id",
        }).EQUAL
      );
    }
    if (filter && filter.groupCode) {
          operators.push(
            getOperator(
              "cast(userGroups",
              "group_code  AS text)",
              "LIKE",
              globalConfig.formatters.getLikeValue(filter.groupCode),
              "group_code"
            )
          );
    }

      if ( operatorsRoleVendor.length> 0 ){
            operators.push( { or: {
              operators :[... operatorsRoleVendor]
            } 
          })
      }      
  
    setOtherFilters(operators, qc_header);
  
    const res = await api().get(settings.api_query_url, {
      headers: headers({
        qc: JSON.stringify(qc_header.qc),
      }),
    });
    
    const response = {
        systemUid: "odm-user",
        items: res.data.map((resItem: any) => {
          return {
            value: resItem.id,
            label: resItem.first_name+' '+resItem.last_name,
            config:{
              network_node_id : resItem.network_node_id
            }
          };
        }),
      };
      return response
    
  }

  export async function  createTeam(team: any) { 
    return apiAnonymousToken().post(`${baseUrl}/team/`, team)
  }

  export async function  getTeam(resourceUid: any) {  
    return apiAnonymousToken().get(`${baseUrl}/team/`+resourceUid+'/')
  }

  export async function  updateTeam(resourceUid:any,team: any) {  
    return apiAnonymousToken().put(`${baseUrl}/team/`+resourceUid+'/', team)
  }

  function handleTeamMembers(teamMembers:any, allSecretarys:any){
    let associations = { members: [], secretary: {} };
    let members: any = [];
    let secretary = {
      type : {
          value:'',
          label:''
        }
  }
        let sec : any 
        for(const member of  teamMembers){
          const memberUid : any = member.member.resourceUid;
            const sec = allSecretarys.items.find((s: any) => s.value === memberUid);
            if (sec && sec.value) {
              secretary.type.value=sec?.value
              secretary.type.label=sec?.label
            }
            else {
              members.push(memberUid)
            }
        }
        associations.members=members
        associations.secretary=secretary
      return associations
}
 async function handleGroupAndMembers(teamMembers:any){
    let distinctGroups : any = [];
    let groupAndMembers : any = [];
    const elementTemplate = {
      group: { value: '', label: '' }
    };

        const allGroups = teamMembers.map((item: any) => item.securityGroup &&  item.securityGroup.resourceUid )
                                     .filter((item: any) => item !== null);
         for(const group of  allGroups){
            if (!distinctGroups.includes(group) && group !== null){
                distinctGroups.push(group)
            }
         }
         if (distinctGroups.length >0) {
           for(const gr of  distinctGroups){
          const groupMembers = teamMembers.filter((item: any) => item.securityGroup && item.securityGroup.resourceUid === gr)
                                           .map((item: any) => item.member?.resourceUid);
            
          const emptyGroupAndMembers = {
            ...elementTemplate,
            id: Date.now().toString() + Math.random().toString(36).substring(2,5),                         
            group :  {
               value: gr,
               label: i18n.global.t("middleOffice.decision.profil." + gr)
            },
            members : groupMembers.length > 0 ? groupMembers : [],
            membersOptionsList: []
          }
            const filter = {
                networkNode: store.state.teamModule.networkNode,
                groupCode:  gr,
            }
            
            const membersOptionsList = await getUsersListToCreateManager(filter)
            emptyGroupAndMembers.membersOptionsList = membersOptionsList && membersOptionsList.items ? membersOptionsList.items : []
             groupAndMembers.push(emptyGroupAndMembers)
        }

         }
         else {
            const emptyGroupAndMembers ={
              ...elementTemplate,
              id: Date.now().toString() + Math.random().toString(36).substring(2,5),    
              group :  {
                value: "",
                label: ""
              },
              members : teamMembers.length > 0 ? teamMembers.map((item: any) => item.member?.resourceUid) : [],
              membersOptionsList: []
            }
              const filter = {
                networkNode: store.state.teamModule.networkNode
              }
            const membersOptionsList = await getUsersListToCreateManager(filter)
              emptyGroupAndMembers.membersOptionsList = membersOptionsList && membersOptionsList.items ? membersOptionsList.items : []
             groupAndMembers.push(emptyGroupAndMembers)
         }
        
      return groupAndMembers
}
  export const executeSaveTeam = async (payload: any) => {
    let team 
    let clone
    let teamMembers : any = []
    unmountSelectFieldsV2(payload, ["manager"]);
    unmountSelectFieldsV2(payload, ["secretary"]);
    unmountSelectFieldsV2(payload, ["typeActivity"]);
    const body =   deepClone(store.getters["teamModule/getTeamEmpty"]);
    body.networkNode = {
      resourceUid: payload.network,
      objectType: "odm.party.networknode",
      systemUid: "odm-user",
    }
    body.manager.resourceUid = payload && payload.manager && payload.manager.resourceUid 
                                    ? payload.manager.resourceUid 
                                    : null
    body.typeActivity.resourceUid = payload && payload.typeActivity && payload.typeActivity.resourceUid && payload.typeActivity.resourceUid
                                    ? payload.typeActivity.resourceUid
                                    : null
    body.description = payload && payload.description
                                    ? payload.description
                                    : ''
    if (payload.validity && payload.validity.from){
        body.validity = {
            from: moment(payload.validity.from,  'DD/MM/YYYY').format('YYYY-MM-DD'),
            until: payload.validity.until ? moment(payload.validity.until,  'DD/MM/YYYY').format('YYYY-MM-DD') : ''
        }
    }  
    
     if (payload.groupAndMembers && payload.groupAndMembers.length >0) {
        for(const element of payload.groupAndMembers){
             for(const member of element.members){
                const emptyTeamMember = deepClone(store.getters["teamModule/getTeamMemberEmpty"]); 
                emptyTeamMember.securityGroup.resourceUid = element?.group?.value
                emptyTeamMember.member.resourceUid = member
                teamMembers.push(emptyTeamMember)
             }
        }
      body.members = teamMembers
    }
                       
    body.businessData=payload.businessData                      
    if (payload && !payload.resourceUid) {
         team = await createTeam(body)
    }
    else if (payload && payload.resourceUid) 
    {
        body.resourceUid = payload && payload.resourceUid
                                    ? payload.resourceUid
                                    : null               
         team = await updateTeam(payload.resourceUid, body)
    }
    if (team ) {
        clone = deepClone(team)
         mountSelectFields(clone.data, ['manager'])
         mountSelectFields(clone.data, ['typeActivity'])
    }



    if (clone && clone.data.members) {
      const filterSecretary= {
        roleCode: "SECRETARY",
      }
      const groupAndMembers : any = await handleGroupAndMembers (clone.data.members)
      clone.data.groupAndMembers = groupAndMembers.length>0 ? groupAndMembers : deepClone(store.getters["teamModule/getTeamMemberEmpty"])
    }
   return clone
  }

  function intiValidity(body: any) {
    body.validity = {
      from: "",
      until: ""
    }
  }

  export async function  executeGetTeam(resourceUid: any) {  
    let clone : any
    const team = await getTeam(resourceUid)
      if (team ) {

        clone = deepClone(team)
        store.commit("teamModule/setNetworkNode", clone.data.networkNode.resourceUid);
        const filter= {
          id: clone.data.manager.resourceUid
        }
        const selectedManager : any =  await getUsersListToCreateManager(filter)
        const manager = {
            type : {
                value: clone.data.manager.resourceUid,
                label: selectedManager &&
                       selectedManager.items && 
                       selectedManager.items[0]  && 
                       selectedManager.items[0].label
                       ? selectedManager.items[0].label 
                       : clone.data.manager.resourceUid
              }
        }   
        clone.data.manager = manager
         let typeActivity : any
         if (clone.data.typeActivity !== null && clone.data.typeActivity.resourceUid !== null){
           typeActivity = {
              type : {
                value: clone.data.typeActivity.resourceUid,
                label: i18n.global.t("asset.vehicleType." + clone.data.typeActivity.resourceUid)
              }
           }
          }
          else {
            typeActivity = {
              type : {
                value: "",
                label: ""
              }
            }
          } 
         clone.data.typeActivity = typeActivity
        if (!clone.data.validity) {
            intiValidity(clone.data)
         }
         else {
            clone.data.validity.from = clone.data.validity.from 
            ? clone.data.validity.from : ''
            clone.data.validity.until = clone.data.validity.until 
            ? clone.data.validity.until : ''

         }
    }

    if (clone && clone.data.members) {
      const filterSecretary= {
        roleCode: "SECRETARY",
      }
      const allSecretarys : any =  await getUsersListToCreateManager(filterSecretary)
      const groupAndMembers : any = await handleGroupAndMembers (clone.data.members)
      clone.data.groupAndMembers = groupAndMembers.length>0 ? groupAndMembers : deepClone(store.getters["teamModule/getTeamMemberEmpty"])

      return clone
    }
}
    

  export function getQcSearchTeams(filter: any, offset?: any, limit?: any): any {
      const qc_header: any = {
        qc: {
          queryId: "search-team",
            offset: offset || 0,
            limit: limit || 100,
        },
      };
      qc_header.qc.parameters = {
        ...filter,
      };
      const operators:any = [];
      
      if (filter && filter.networkNode !== undefined) {
        operators.push(
          getOperator(
            "user_team",
            "network_node_resourceuid",
            "EQUAL",
            globalConfig.formatters.getEqualValue(filter.networkNode),
            "network_node_resourceuid"
          )
        );
      }
      if (filter && filter.manager !== undefined) {
        operators.push(
            getOperator(
              "user_team",
              "manager_code",
              "EQUAL",
              globalConfig.formatters.getEqualValue(filter.manager),
              "manager_code"
            )
          );
      }
      if (filter && filter.description) {
        operators.push(
            getOperator(
              "lower(user_team",
              "_description)",
              "LIKE",
              globalConfig.formatters
                .getLikeValue(filter.description)
                .toLowerCase(),
              "_description"
            )
          );
      }

      if (filter?.member && filter.member !== null && filter.member.length > 0) {
        const listUsers = Array.isArray(filter.member) ? filter.member : [filter.member];
        operators.push(getInOperator("user_team_member", "member_code", "IN", null, null, globalConfig.formatters.getInValue(listUsers)))
   
      }
      operators.push(getOperator("user_team", "network_node_resourceuid", "ISNOTNULL"));
      if (operators.length > 0) {
        qc_header.qc.otherFilters = {
          expressions: [
            {
              and: {
                operators,
              },
            },
          ],
        };
      }
        return qc_header.qc;
}

      export function searchTeams(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchTeams(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
          axios.get(url, {
            headers: _headers
          }).then(res => {
            resolve(res.data)
          }).catch(err => reject(err))
      })
      }
